var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCircleX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(640.7 1471.452)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 86",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(-640.7 -1471.452)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 2459",
    d: "m-605.6-1419.231-2.3-2.29 2.28-2.275.26-.262-.26-.262-.333-.337-.289-.3-.289.3-2.252 2.247-2.217-2.211-.289-.3-.289.3-.333.337-.26.262.26.262 2.245 2.24-2.268 2.255-.26.262.26.262.332.336.015.015.016.014.305.248.257-.283 2.226-2.22 2.26 2.255.257.283.305-.248.016-.014.014-.015.332-.336.26-.262z",
    transform: "translate(-23.929 -41.929)",
    style: {
      fill: "#f8fafb"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCircleX);
export default __webpack_public_path__ + "static/media/ic-circle-x.bf14fb22089f2be79a7955283e1cf31b.svg";
export { ForwardRef as ReactComponent };